import React, { useEffect, useState } from "react";
import { Button, Col, Container, Form, Row } from "react-bootstrap";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import Select from "react-select";
import { toast } from "react-toastify";
import { z } from "zod";
import user from "../../../../Assets/images/user.png";
import AddressInput from "../../../../components/Common/address";
import {
  ADD_DRIVER,
  EDIT_DRIVER,
  GET_DOCUMENTS,
  GET_DRIVER_BY_ID,
  GET_SERVICES,
} from "../../../../services/ApiCalls";
import fileUploader from "../../../../utilities/fileUploader";

const AddDriver = () => {
  const { id } = useParams();

  const schema = z.object({
    name: z.string().trim().min(1, { message: " name is required" }),
    operationScope: z
      .string()
      .trim()
      .min(1, { message: "Operation Scope is required" }),
    email: z
      .string({
        required_error: "email is required",
      })
      .min(1, { message: "Email is required" })
      .email("Invalid email address"),
    address: z.string().trim().min(1, { message: "Address is required" }),
    ...(!id && {
      password: z.string().min(1, { message: "Password is required" }),
    }),
    // bank details
    routingNumber: z
      .string()
      .trim()
      .min(1, { message: "Routing Number is required" }),
    accountNumber: z
      .string({
        required_error: "Account Number is required",
      })
      .min(1, { message: "Account Number is required" })
      .refine((data) => !isNaN(data), {
        message: "Account Number only contain a Numeric value",
      }),

    accountHolderName: z
      .string()
      .trim()
      .min(1, { message: "Account HolderName  is required" }),
    bankName: z.string().trim().min(1, { message: "Bank Name   is required" }),
    vehiclePlateNumber: z
      .string()
      .trim()
      .min(1, { message: "vehicle Plate Number Number is required" }),
    vehicleMake: z
      .string()
      .trim()
      .min(1, { message: "vehicle Make  is required" }),
    vehicleModel: z
      .string()
      .trim()
      .min(1, { message: "vehicle Model is required" }),
    vehicleColor: z
      .string()
      .trim()
      .min(1, { message: "vehicle Color is required" }),
    serviceType: z
      .string()
      .trim()
      .min(1, { message: "Service Type  is required" }),
  });

  const [contactNumber, setContactNUmber] = useState({
    countryCode: "",
    mobileNumber: "",
  });
  const [Error, setError] = useState({
    contactNumber: "",
  });
  const [showPass, setShowPass] = useState({
    password: false,
    confirmPassword: false,
  });
  const [documentsConfig, setDocumentsConfig] = useState([]);
  const [driverDetail, setDriverDetail] = useState();
  const navigate = useNavigate();
  const [profileImage, setProfileImage] = useState("");
  const [allServices, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState([]);

  const buildDynamicSchema = (documentsConfig) => {
    const shape = {};

    documentsConfig.forEach((doc) => {
      let field;

      // ✅ TEXT FIELD
      if (doc.type === "text") {
        field = z.string().trim();

        if (doc.isRequired) {
          field = field.min(1, { message: doc.message });
        } else {
          field = field.optional();
        }

        // Optional meta validations
        if (doc.meta?.minLength) {
          field = field.min(doc.meta.minLength, {
            message: `${doc.label} must be at least ${doc.meta.minLength} characters`,
          });
        }

        if (doc.meta?.maxLength) {
          field = field.max(doc.meta.maxLength, {
            message: `${doc.label} must be less than ${doc.meta.maxLength} characters`,
          });
        }

        if (doc.meta?.pattern) {
          field = field.regex(new RegExp(doc.meta.pattern), {
            message: doc.meta?.patternMessage || `${doc.label} is invalid`,
          });
        }
      }

      // ✅ FILE FIELD
      if (doc.type === "file") {
        field = z.any();

        if (doc.isRequired) {
          field = field.refine((val) => !!val, {
            message: doc.message,
          });
        } else {
          field = field.optional();
        }
      }

      shape[doc.documentName] = field;
    });

    return z.object(shape);
  };
  const dynamicSchema = buildDynamicSchema(documentsConfig);

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    trigger,
    watch,
  } = useForm({
    resolver: zodResolver(schema.merge(dynamicSchema)),
    values: {
      name: driverDetail?.providerDetails?.name || "",
      email: driverDetail?.providerDetails?.email || "",
      operationScope: driverDetail?.providerDetails?.operationScope || "",
      address: driverDetail?.providerDetails?.address || "",
      password: "",
      routingNumber: driverDetail?.accountDetails?.routingNumber || "",
      accountNumber: driverDetail?.accountDetails?.accountNumber || "",
      accountHolderName: driverDetail?.accountDetails?.accountHolderName || "",
      bankName: driverDetail?.accountDetails?.bankName || "",
      vehiclePlateNumber: driverDetail?.vehicleDetails?.plateNumber || "",
      vehicleMake: driverDetail?.vehicleDetails?.make || "",
      vehicleModel: driverDetail?.vehicleDetails?.model || "",
      vehicleColor: driverDetail?.vehicleDetails?.color || "",
      serviceType: driverDetail?.providerDetails?.serviceType || "",
      services:
        driverDetail?.selectedServices?.map((service) => service.id) || [],
    },
  });

  const getDocuments = async (operationScope, vehicleWeight) => {
    try {
      const res = await GET_DOCUMENTS({
        operationScope,
        vehicleWeight,
      });

      if (res?.data?.status === "success") {
        setDocumentsConfig(res.data.data); // ✅ store config
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("Failed to fetch documents");
    }
  };

  const operationScope = watch("operationScope");
  // const services = watch("services");

  useEffect(() => {
    if (
      operationScope &&
      selectedService.length > 0 &&
      allServices.length > 0
    ) {
      const service = allServices.find((val) => val.id === selectedService[0]);

      if (service) {
        getDocuments(operationScope, service.weightCapacity);
      }
    }
  }, [operationScope, selectedService, allServices]);

  // ✅ FIXED: Populate dynamic fields on edit with existing document values
  useEffect(() => {
    if (!id) {
      // For add mode, clear all dynamic fields
      documentsConfig.forEach((doc) => {
        setValue(doc.documentName, "");
      });
    } else if (driverDetail?.providerDetails?.documentsList) {
      // For edit mode, populate dynamic fields with existing values
      documentsConfig.forEach((doc) => {
        const existingDoc = driverDetail.providerDetails.documentsList.find(
          (item) => item.documentType === doc.documentName,
        );

        if (existingDoc) {
          console.log(doc, existingDoc, "hhhhh");
          setValue(
            doc.documentName,
            existingDoc.value || existingDoc.image || "",
          );
        }
      });
    }
  }, [documentsConfig, driverDetail, id]);

  const imageChangeHandler = async (e) => {
    const url = await fileUploader(e.target.files[0]);
    if (!url) {
      return;
    }

    setProfileImage((p) => url);
  };

  const editHandler = async (data) => {
    try {
      const documentsList = documentsConfig.map((doc) => ({
        ...doc,
        value: data[doc.documentName] || "",
      }));

      const payload = {
        driverId: id,
        ...data,
        ...contactNumber,
        // documentsList: documentImages?.map((item) => ({ image: item })),
        documentsList,
        selectedServices: selectedService,
        services: selectedService,
        profileImage,
      };

      payload.bankDetails = {
        routingNumber: data.routingNumber,
        accountNumber: data.accountNumber,
        accountHolderName: data.accountHolderName,
        bankName: data.bankName,
      };

      payload.vehicleDetails = {
        vehiclePlateNumber: data.vehiclePlateNumber,
        vehicleMake: data.vehicleMake,
        vehicleModel: data.vehicleModel,
        vehicleColor: data.vehicleColor,
      };

      delete payload.vehiclePlateNumber;
      delete payload.vehicleMake;
      delete payload.vehicleModel;
      delete payload.vehicleColor;

      delete payload.routingNumber;
      delete payload.accountNumber;
      delete payload.accountHolderName;
      delete payload.bankName;

      const res = await EDIT_DRIVER(payload);

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/manage-driver");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrongw");
    }
  };
  const submitHandler = async (data) => {
    const documentsList = documentsConfig.map((doc) => ({
      ...doc,
      value: data[doc.documentName] || "",
    }));
    if (
      !contactNumber.countryCode.trim() ||
      !contactNumber.mobileNumber.trim()
    ) {
      return setError((p) => ({
        ...p,
        contactNumber: "Phone Number is Required",
      }));
    } else {
      setError((p) => ({ ...p, contactNumber: "" }));
    }

    if (!profileImage) {
      return toast.error("please add the profile image");
    }

    // if (documentImages.length === 0) {
    //   return toast.error("please add the documents image");
    // }
    if (selectedService.length === 0) {
      return toast.error("please add the service ");
    }

    if (id) {
      return editHandler(data);
    }

    try {
      const payload = {
        ...data,
        ...contactNumber,
        // documentsList: documentImages?.map((item) => ({ image: item })),
        documentsList,
        selectedServices: selectedService,
        services: selectedService,
        profileImage,
      };
      // return console.log(payload, "payload");
      const res = await ADD_DRIVER(payload);

      if (res?.data?.status === "success") {
        toast.success(res?.data?.message);
        navigate("/manage-driver");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrong");
    }
  };

  const getDriver = async () => {
    try {
      const res = await GET_DRIVER_BY_ID(id);

      if (res?.data?.status === "success") {
        const driverData = res?.data?.data?.providerDetails;
        setDriverDetail(res?.data?.data);
        setProfileImage(res?.data?.data?.providerDetails?.profileImage);
        setSelectedService([
          res?.data?.data?.providerDetails?.selectedServices[0].serviceId,
        ]);

        setContactNUmber({
          mobileNumber: res?.data?.data?.providerDetails?.mobileNumber,
          countryCode: res?.data?.data?.providerDetails?.countryCode,
        });
        if (driverData?.providerDetails?.address) {
          setValue("address", driverData);
        }
        await handleServiceSelect({ type: driverData?.serviceType });

        console.log(driverData, "driverData");
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      toast.error("something went wrongww");
    }
  };
  const handlePassword = (fieldName) => {
    setShowPass((prevState) => ({
      ...prevState,
      [fieldName]: !prevState[fieldName],
    }));
  };
  const handleServiceSelect = async (option) => {
    let type = option.type;
    try {
      const res = await GET_SERVICES({ type });
      if (res.data.status === "success") {
        setServices(
          res.data?.data?.map((item) => {
            const additionalFields = (
              <div className="d-flex justify-content-between">
                <img
                  src={item.image}
                  alt={item.name}
                  style={{ width: "30px", height: "30px" }}
                />
                <span>{item.name}</span>
                <span style={{ color: "gray" }}>
                  {" "}
                  {item.weightCapacity}(lb)
                </span>
              </div>
            );
            return {
              id: item._id,
              image: item.image,
              weightCapacity: item.weightCapacity,
              label: additionalFields,
              labelValue: item.name,
              value: item._id,
            };
          }),
        );
      } else {
        console.error("Failed to fetch serviceType details", res.error);
      }
    } catch (error) {
      console.error("Error fetching serviceType details:", error);
    }
  };

  useEffect(() => {
    if (id) getDriver(id);
  }, [id]);

  return (
    <>
      <section className="EdirDriver py-3 position-relative">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="sectionHeader">
                <h3 className="m-0 fw-sbold themeBlue">
                  {id ? "Edit Driver Details" : "Add Driver"}
                </h3>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <Form onSubmit={handleSubmit(submitHandler)}>
                <Row className="justify-content-center">
                  <Col md="6" className="my-2">
                    <div className="py-2">
                      <div className="py-2 head">
                        <h6 className="m-0 fw-bold">Personal Details</h6>
                      </div>
                      <div className="py-2">
                        <div
                          className={` d-flex gap-10 align-items-start position-relative`}
                        >
                          <div className="left position-relative">
                            <div
                              className={` imgWrp mx-auto rounded-circle`}
                              style={{
                                background: "rgb(243, 243, 243)",
                                height: 100,
                                width: 100,
                                aspectRatio: 1,
                              }}
                            >
                              <input
                                type="file"
                                className="file position-absolute h-100 w-100"
                                onChange={(e) => imageChangeHandler(e)}
                              />
                              <img
                                src={profileImage || user}
                                alt=""
                                className="img-fluid w-100 h-100 rounded-circle"
                              />
                              <span
                                className="icn position-absolute"
                                style={{ right: 0, bottom: 0 }}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="36"
                                  height="36"
                                  viewBox="0 0 36 36"
                                  fill="none"
                                >
                                  <circle
                                    cx="18"
                                    cy="18"
                                    r="18"
                                    fill="#C11111"
                                  />
                                  <g clip-path="url(#clip0_14_237)">
                                    <path
                                      d="M15.4568 25.098C15.2648 25.098 15.0728 25.0245 14.9265 24.8783L11.1218 21.0735C10.8285 20.7803 10.8285 20.3063 11.1218 20.013L19.9995 11.136C20.2928 10.8428 20.7668 10.8428 21.06 11.136L24.8648 14.9408C25.158 15.234 25.158 15.708 24.8648 16.0013L15.987 24.8783C15.8408 25.0245 15.6488 25.098 15.4568 25.098ZM12.7125 20.5433L15.4568 23.2875L23.2733 15.4703L20.529 12.726L12.7125 20.5433Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M9.74996 27C9.55421 27 9.36221 26.9235 9.21971 26.7803C9.01871 26.5793 8.94896 26.2823 9.03821 26.013L10.9402 20.3063C11.0227 20.0595 11.2267 19.8735 11.4795 19.8135C11.7322 19.7543 11.9985 19.8293 12.1822 20.013L15.987 23.8178C16.1707 24.0015 16.2465 24.2678 16.1865 24.5205C16.1265 24.7733 15.9405 24.9773 15.6937 25.0598L9.98696 26.9618C9.90896 26.9873 9.82946 27 9.74996 27ZM11.9797 21.9315L10.9357 25.0643L14.0685 24.0203L11.9797 21.9315Z"
                                      fill="white"
                                    />
                                    <path
                                      d="M24.3337 16.2202C24.1417 16.2202 23.9497 16.1467 23.8035 16.0005L19.9987 12.1957C19.7055 11.9025 19.7055 11.4285 19.9987 11.1352L21.4762 9.65775C22.3522 8.781 23.7787 8.781 24.6547 9.65775L26.3415 11.3445C27.2175 12.2205 27.2175 13.647 26.3415 14.523L24.864 16.0005C24.7177 16.1475 24.5257 16.2202 24.3337 16.2202ZM21.5902 11.6662L24.3345 14.4105L25.2817 13.4632C25.5735 13.1715 25.5735 12.6975 25.2817 12.4057L23.595 10.719C23.3032 10.4272 22.8292 10.4272 22.5375 10.719L21.5902 11.6662Z"
                                      fill="white"
                                    />
                                  </g>
                                  <defs>
                                    <clipPath id="clip0_14_237">
                                      <rect
                                        width="18"
                                        height="18"
                                        fill="white"
                                        transform="translate(9 9)"
                                      />
                                    </clipPath>
                                  </defs>
                                </svg>
                              </span>
                            </div>
                          </div>
                          <div className="right mt-4">
                            <h6 className="m-0 fw-bold">Upload Image</h6>
                          </div>
                        </div>
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Jane Cooper"
                          className="form-control ps-3"
                          {...register("name")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.name && errors.name.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <PhoneInput
                          value={`${contactNumber.countryCode}Code, "+" + ${contactNumber.mobileNumber}`}
                          onChange={(mobileNumber, { dialCode }) => {
                            setContactNUmber((p) => ({
                              countryCode: `+${dialCode}`,
                              mobileNumber: mobileNumber.replace(dialCode, ""),
                            }));
                          }}
                          country={"us"}
                        />
                        {
                          <p className="errorColor">
                            {Error?.contactNumber && Error.contactNumber}
                          </p>
                        }
                      </div>

                      <div className="py-2 mb-2">
                        <AddressInput
                          name="address"
                          placeholder="Enter your Address"
                          errorLabel="Address"
                          required
                          defaultValue=""
                          setValue={(val) => setValue("address", val)}
                          trigger={() => trigger("address")}
                          value={watch("address")}
                        />
                        {errors.address && (
                          <p className="errorColor">{errors.address.message}</p>
                        )}
                      </div>
                      <div className="py-2">
                        <input
                          type="email"
                          placeholder="Enter Email Address"
                          className="form-control ps-3"
                          {...register("email")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.email && errors.email.message}
                          </p>
                        }
                      </div>

                      {!id && (
                        <div className="py-2 position-relative">
                          <input
                            type={showPass.password ? "text" : "password"}
                            placeholder="Enter Password"
                            className="form-control ps-3"
                            {...register("password")}
                          />
                          <Button
                            variant="transparent"
                            onClick={() => handlePassword("password")}
                            className="border-0 p-0 position-absolute icn"
                            style={{ right: 10, top: "20px" }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 25 17"
                              fill="none"
                            >
                              <path
                                d="M24.8389 7.9541C22.8564 5.34668 20.8301 3.35937 18.8184 2.04102C16.7578 0.693359 14.6582 0.00488281 12.5684 0C12.5586 0 12.5488 0 12.5391 0C10.4443 0 8.3252 0.683594 6.25 2.03613C4.22363 3.34961 2.17285 5.3418 0.161133 7.94922C-0.0537109 8.23242 -0.0537109 8.62305 0.161133 8.90137C2.17285 11.5137 4.22363 13.5059 6.25 14.8193C8.33008 16.1719 10.4443 16.8555 12.5391 16.8555H12.5684C14.6582 16.8506 16.7627 16.1621 18.8184 14.8145C20.8301 13.4961 22.8516 11.5088 24.8389 8.90137C25.0537 8.62305 25.0537 8.23242 24.8389 7.9541ZM12.5635 15.293C12.5537 15.293 12.5439 15.293 12.5391 15.293C9.02832 15.293 5.40527 12.9834 1.77246 8.42773C5.40527 3.87207 9.02344 1.5625 12.5391 1.5625H12.5635C16.0645 1.57227 19.6533 3.88184 23.2275 8.42773C19.6533 12.9736 16.0693 15.2832 12.5635 15.293ZM12.5 3.54492C9.80957 3.54492 7.61719 5.73731 7.61719 8.42773C7.61719 11.1182 9.80957 13.3105 12.5 13.3105C15.1904 13.3105 17.3828 11.1182 17.3828 8.42773C17.3828 5.73731 15.1904 3.54492 12.5 3.54492ZM12.5 11.748C10.6689 11.748 9.17969 10.2588 9.17969 8.42773C9.17969 6.59668 10.6689 5.10742 12.5 5.10742C14.3311 5.10742 15.8203 6.59668 15.8203 8.42773C15.8203 10.2588 14.3311 11.748 12.5 11.748Z"
                                fill="#666666"
                              ></path>
                            </svg>
                          </Button>
                          <p className="errorColor">
                            {errors?.password && errors.password.message}
                          </p>
                        </div>
                      )}
                    </div>

                    <div className="py-2">
                      <div className="py-2 head">
                        <h4 className="m-0 themeBlue fw-bold">Bank Details </h4>
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Bank Name"
                          className="form-control ps-3"
                          {...register("bankName")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.bankName && errors.bankName.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Account Number"
                          className="form-control ps-3"
                          {...register("accountNumber")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.accountNumber &&
                              errors.accountNumber.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Routing Number"
                          className="form-control ps-3"
                          {...register("routingNumber")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.routingNumber &&
                              errors.routingNumber.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Account Holder Name"
                          className="form-control ps-3"
                          {...register("accountHolderName")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.accountHolderName &&
                              errors.accountHolderName.message}
                          </p>
                        }
                      </div>
                    </div>
                  </Col>
                  <Col md="6" className="my-2">
                    <div className="py-2">
                      <div className="py-2 head">
                        <h4 className="m-0 themeBlue fw-bold">
                          Add Vehicle Details
                        </h4>
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle license plate number"
                          className="form-control ps-3"
                          {...register("vehiclePlateNumber")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehiclePlateNumber &&
                              errors.vehiclePlateNumber.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle make"
                          className="form-control ps-3"
                          {...register("vehicleMake")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehicleMake && errors.vehicleMake.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle model"
                          className="form-control ps-3"
                          {...register("vehicleModel")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehicleModel &&
                              errors.vehicleModel.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <input
                          type="text"
                          placeholder="Vehicle color"
                          className="form-control ps-3"
                          {...register("vehicleColor")}
                        />
                        {
                          <p className="errorColor">
                            {errors?.vehicleColor &&
                              errors.vehicleColor.message}
                          </p>
                        }
                      </div>
                      <div className="py-2">
                        <select
                          className="form-control ps-3"
                          {...register("serviceType")}
                          onChange={(e) => {
                            const selectedValue = e.target.value;
                            setValue("serviceType", selectedValue);
                            handleServiceSelect({ type: selectedValue }); // Fetch services based on type
                          }}
                        >
                          <option value="">Select Vehicle Type</option>
                          <option value="PickupDrop">Pickup Drop</option>
                          <option value="Towing">Towing</option>
                        </select>
                        {
                          <p className="errorColor">
                            {errors?.serviceType && errors.serviceType.message}
                          </p>
                        }
                      </div>

                      <div className="pt-4">
                        <Select
                          options={allServices}
                          value={allServices.find(
                            (service) => service.id === selectedService?.[0],
                          )}
                          isMulti={false}
                          onChange={(e) => {
                            const selectedValue = e.id;
                            setSelectedService([selectedValue]);
                          }}
                        ></Select>
                      </div>
                      <div className="py-2">
                        <select
                          className="form-control ps-3"
                          {...register("operationScope")}
                        >
                          <option value="">Select Operation Scope</option>
                          <option value="interstate">Out of state Routes</option>
                          <option value="intrastate">State in my state Routes</option>
                        </select>

                        <p className="errorColor">
                          {errors?.operationScope &&
                            errors.operationScope.message}
                        </p>
                      </div>
                    </div>

                    <div className="py-2">
                      <div className="py-2 head">
                        <h4 className="m-0 themeBlue fw-bold">Documents</h4>
                      </div>

                      {documentsConfig.map((doc) => (
                        <div key={doc.documentName} className="py-2">
                          <label className="fw-bold">
                            {doc.label} {doc.isRequired && "*"}
                          </label>

                          {/* TEXT INPUT */}
                          {doc.type === "text" && (
                            <input
                              type="text"
                              className="form-control"
                              placeholder={`Enter ${doc.label}`}
                              {...register(doc.documentName)}
                            />
                          )}

                          {/* FILE INPUT */}
                          {doc.type === "file" && (
                            <>
                              <input
                                type="file"
                                className="form-control"
                                onChange={async (e) => {
                                  const file = e.target.files[0];
                                  if (!file) return;

                                  const url = await fileUploader(file);

                                  setValue(doc.documentName, url, {
                                    shouldValidate: true, // ✅ trigger validation
                                  });
                                }}
                              />

                              {/* Preview */}
                              {watch(doc.documentName) && (
                                <>
                                  {watch(doc.documentName)
                                    ?.split(".")
                                    ?.pop() === "pdf" ? (
                                    <a
                                      href={watch(doc.documentName)}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      View PDF
                                    </a>
                                  ) : (
                                    <img
                                      src={watch(doc.documentName)}
                                      alt=""
                                      style={{ height: 80, marginTop: 10 }}
                                    />
                                  )}
                                </>
                              )}
                            </>
                          )}

                          {/* ERROR */}
                          <p className="errorColor">
                            {errors?.[doc.documentName]?.message}
                          </p>
                        </div>
                      ))}
                    </div>
                  </Col>
                  <Row>
                    <Col lg="4" sm="6" className="my-1">
                      <Button
                        className="d-flex align-items-center justify-content-center commonBtn w-100"
                        type="submit"
                      >
                        Save
                      </Button>
                    </Col>
                  </Row>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AddDriver;
